import CT from '@marketplace-ai/tags';
import { EducationDetails } from './education/EducationDetails';
import { TrainingDetails } from './training/TrainingDetails';

const TAGS = CT.academics.page;

export const ACADEMICS_TABS = [
  {
    name: 'Education',
    current: true,
    layout: EducationDetails,
    cyTag: TAGS.educationTab,
  },
  {
    name: 'Training',
    current: false,
    layout: TrainingDetails,
    cyTag: TAGS.trainingTab,
  },
];
